import { Locale } from '@ps-smart-cp/ppfw-client';

const closingStatusNameConfig = {
  normal: new Map([
    [Locale.ja, '通常'],
    [Locale.en, 'Normal'],
  ]),
  provisionalCutoff: new Map([
    [Locale.ja, '仮締め'],
    [Locale.en, 'Provisional Cutoff'],
  ]),
  finalCutoff: new Map([
    [Locale.ja, '本締め'],
    [Locale.en, 'Final Cutoff'],
  ]),
  afterClosing: new Map([
    [Locale.ja, '確定後'],
    [Locale.en, 'After Closing'],
  ]),
  beforeStartOfFiscalYear: new Map([
    [Locale.ja, '年度開始前'],
    [Locale.en, 'Before Start Of Fiscal Year'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { closingStatusNameConfig };
